module.exports = __webpack_public_path__ + "img/member_center_footer.df73e5c8.png";